import { render, staticRenderFns } from "./View5.vue?vue&type=template&id=6341e44e&scoped=true&"
import script from "./View5.vue?vue&type=script&lang=js&"
export * from "./View5.vue?vue&type=script&lang=js&"
import style0 from "./View5.vue?vue&type=style&index=0&id=6341e44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341e44e",
  null
  
)

export default component.exports